export const ChoosedayConfig = {
    roll: {
        min: 1,
        max: 100,
    },
};
